module.exports = {"id":"188427","name":"Senad Lulić","rating":"79","photo":"./data/images/photos/2/188427.png","club":{"name":"Lazio Rome","logo":"./data/images/clubs/LazioRome.png"},"positions":["MG","DG","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SenadLulic0.json
// module id = 3888
// module chunks = 0